var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"previewModal",attrs:{"size":"lg","title":"Förhandsvisning av Widget","hide-footer":""},on:{"hide":function($event){return _vm.$emit('close')}}},[(_vm.customerId)?_c(_vm.form.componentName,{tag:"component",attrs:{"widget":_vm.form,"customerId":_vm.customerId,"startDate":_vm.startDate,"endDate":_vm.endDate}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }